import { RadioButton } from "primereact/radiobutton";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { selectedPayment } from "../../redux/slices/payments";

const InvoicePaymentMode = (props:any) => {
  
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectedPaymentMode = useAppSelector((state) => state.payments);
  const [selectedPaymentId, setSelectedPaymentId] = useState<number>(6);
  
  let paymentmodesdata = [    
    {
      id: "6",
      mode: "Payment Link",
      code: "",
      modeImage: process.env.PUBLIC_URL + "/assests/images/Betaallink.png",
      isSelected: true,
    },
    {
      id: "5",
      mode: "UPI ",
      code: "OPTUPI",
      modeImage: process.env.PUBLIC_URL + "/assests/images/oup.jpg",
      isSelected: false,
    }
  ];  

  useEffect(() => {
    if (selectedPaymentMode.selectedPayment === null) {
      setSelectedPaymentId(6);
    } else {
      setSelectedPaymentId(selectedPaymentMode.selectedPayment.id);
    }
  });

  useEffect(() => {
    props.updatePaymentId(selectedPaymentId);
  }, [selectedPaymentId]);

  const savePaymentMode = (e: any, value: any) => {
    setSelectedPaymentId(value.id);
    dispatch(selectedPayment(value));
  };

  return (
    <>      
      <div className="flex flex-wrap gap-3">
        {paymentmodesdata.map((category) => {
          return (
            <div key={category.id} className="ml-3 flex align-items-left">              
              <RadioButton
                inputId={category.id}
                name="category"
                value={category}
                onChange={(e) => savePaymentMode(e, e.value)}
                checked={selectedPaymentId.toString() === category.id}
              />
              <label htmlFor={category.id} className="ml-2 font-medium">
                {category.mode}
              </label>              
              <div className="ml-2 payment-mode-image">
                <Image
                  src={category.modeImage}
                  alt={category.modeImage}
                  className="text-right"
                />
              </div>              
            </div> 
          );
        })}
      </div>          
    </>
  )
}

export default InvoicePaymentMode;